import { apiClient } from "../api/apiclient"

export const postStudentDetails = (requestBody, token, studentId) =>
  apiClient.post("/student-details", requestBody, {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId }
  });

  export const UpdateStudentDetails = (StudentDetailsRequest, token, studentId) =>
  apiClient.put("/student-details", StudentDetailsRequest, {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId }
  });

export const getStudentDetails = (token, studentId) =>
  apiClient.get(`/student-details?studentId=${studentId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getGender = (token) =>
  apiClient.get("/gender", {
    headers: { Authorization: `Bearer ${token}` },
  });
export const getReligion = (token) =>
  apiClient.get("/religion", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getNationality = (token) =>
  apiClient.get("/nationality", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getCasteCategory = (token) =>
  apiClient.get("/castecategory", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getMaritalData = (token) =>
  apiClient.get("/maritalstatus", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getBloodGroup = (token) =>
  apiClient.get("/bloodGroup", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllCategoryType = (token) =>
  apiClient.get("/category-types", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getUniversityboard = (token) =>
  apiClient.get("/universityandboard", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getCourse = (token) =>
  apiClient.get("/courses", {
    headers: { Authorization: `Bearer ${token}` },
  });


export const getAssignedTabs = (courseId, token) =>
  apiClient.get(
    `courses/${courseId}/tabs`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

export const getAssignedDocuments = (courseId, token) =>
  apiClient.get(
    `courses/${courseId}/documents`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

export const PostDocumentDetails = (studentId, courseId, token, details) => {
  return apiClient.post(
    "/upload-document",
    details,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { studentId, courseId }
    }
  )
};
export const getDocumentByStudentID = (token, studentId, courseId) =>
  apiClient.get(
    "/document/course",
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { studentId, courseId },
    }
  );



export const PostLastQualifyingDetails = (request, token, studentId) => {
  return apiClient.post(
    "/last-qualifying-exam",
    request,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { studentId }
    }
  )
};

export const getLastQualifyingDetails = (token, studentId, courseId) =>
  apiClient.get(
    "/last-qualifying-exam/course",
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { studentId, courseId }
    }
  );
//photo and sign

export const uploadPhoto = async (studentId, photoFile, token) => {
  try {
    const formData = new FormData();
    formData.append("photo", photoFile);
    formData.append("studentId", studentId);

    const response = await apiClient.post("/upload-photo", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Photo Upload Response:", response.data);
    return response;
  } catch (error) {
    console.error("Photo Upload Error:", error.response || error.message);
    throw error;
  }
};
export const uploadSign = (studentId, signFile, token) => {
  const formData = new FormData();
  formData.append("studentId", studentId);
  formData.append("sign", signFile);

  return apiClient.post(
    "/upload-sign",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const fetchStudentPhoto = (token, studentId) =>
  apiClient.get("/getphoto", {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId },
    responseType: 'blob'
  });

export const fetchStudentSign = (token, studentId) =>
  apiClient.get("/getsign", {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId },
    responseType: 'blob'
  });


export const getRegisterFees = (courseId, token) =>
  apiClient.get("/registration-fees", {
    headers: { Authorization: `Bearer ${token}` },
    params: { courseId },
  });


//print application

export const getStudentApplicationByStudent = (token, studentId) =>
  apiClient.get("/api/student-applications/get", {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId },
  }
  );

export const getCountries = (token) =>
  apiClient.get("/countries", {
    headers: { Authorization: `Bearer ${token}` },
  }
  );

export const getState = (token, countryId) =>
  apiClient.get("/state/by-country", {
    headers: { Authorization: `Bearer ${token}` },
    params: { countryId }
  }
  );

export const getcity = (token, stateId) =>
  apiClient.get("/city/by-state", {
    headers: { Authorization: `Bearer ${token}` },
    params: { stateId }
  }
  );

export const createStudentApplication = (studentId, courseId, token) =>
  apiClient.post(
    `/api/student-applications/create?studentId=${studentId}&courseId=${courseId}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

//subject details

export const getAllMedium = (token) =>
  apiClient.get("/medium", {
    headers: { Authorization: `Bearer ${token}` },
  }
  );

export const getStudentsAllData = (studentId, courseId, token) =>
  apiClient.get("/student-data", {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId, courseId },
  });


export const getAllSubjectcategory = (token) =>
  apiClient.get("/subject-categories", {
    headers: { Authorization: `Bearer ${token}` },
  }
  );

export const getSubjectCategoryDecipline = (token, subjectCategoryId) =>
  apiClient.get("/subjectCategory-discipline/find", {
    headers: { Authorization: `Bearer ${token}` },
    params: { subjectCategoryId }
  }
  );


export const getSubjectbyCourseAndDiscipline = (token, courseId, disciplineId) =>
  apiClient.get("/course-discipline/find", {
    headers: { Authorization: `Bearer ${token}` },
    params: { courseId, disciplineId }
  }
  );


export const getCourseCreditPreference = (token, subjectCategoryId, courseId) =>
  apiClient.get("/get-course-credits", {
    headers: { Authorization: `Bearer ${token}` },
    params: { subjectCategoryId, courseId },
  });


export const postSubjectPreference = (token, request, studentId, courseId) =>
  apiClient.post("/subject-preference", request, {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId, courseId },
  });

export const fetchSubjectbyStudentID = (token, studentId, courseId) =>
  apiClient.get("/subject-preference/course", {
    headers: { Authorization: `Bearer ${token}` },
    params: { studentId, courseId }
  });
